import { getConfigTenant, isCorpTenant } from "@capone/common";
import fetchCorpUsersList, {
  CorpUsersListResponse,
} from "b2b-base/src/api/v1/user/fetchCorpUsersList";
import { buildCorpTravelers } from "b2b-base/src/utils/capone-corporate/travelersMappingUtils";
import {
  CallState,
  CorpSessionInfo,
  ICorpPerson,
  IPerson,
  SessionInfo,
} from "redmond";
import { all, call, put, select } from "redux-saga/effects";
import fetchUserInfo from "../../api/v1/fetchUserInfo";
import { deleteUserPassenger } from "../../api/v1/user-passengers/deleteUserPassenger";
import {
  fetchUserPassengers,
  IListUserPassengersResponse,
} from "../../api/v1/user-passengers/fetchUserPassengers";
import { getUserSelectedTravelerId } from "../../app/selectors";
import { IDeleteUserPassenger, setUserPassengers, setUserPassengersCallStateFailed, setUserSelectedPassengerIds } from "../../app/actions";
import { IStoreState } from "../../app/store";

export function* deleteUserPassengerSaga(action: IDeleteUserPassenger) {
  try {
    const state: IStoreState = yield select();
    const selectedPassengerId = getUserSelectedTravelerId(state);
    // Note: we only want a single passenger selected at once so we reset entire array if the deleted passenger is the current selected.
    const newSelectedIds =
      selectedPassengerId === action.payload.personId || !selectedPassengerId
        ? []
        : [selectedPassengerId];

    yield deleteUserPassenger(action.payload);

    yield put(
      setUserSelectedPassengerIds({
        userSelectedPassengerIds: newSelectedIds,
      })
    );

    const sessionInfo: SessionInfo = yield call(fetchUserInfo);
    const canViewUsers =
      "corporateInfo" in sessionInfo
        ? (sessionInfo as CorpSessionInfo).corporateInfo.permissions
            .canViewUsers
        : false;

    const travelerDefaultTravelerId =
      ("corporateInfo" in sessionInfo &&
        (sessionInfo as CorpSessionInfo).corporateInfo.defaultTravelerId) ??
      "";

    let userPassengers: IPerson[] | ICorpPerson[];
    if (!isCorpTenant(getConfigTenant())) {
      userPassengers = yield fetchUserPassengers({});
    } else {
      const [corpUsersList, caponeUserPassengers]: [
        CorpUsersListResponse,
        IListUserPassengersResponse
      ] = yield all([
        canViewUsers
          ? call(fetchCorpUsersList)
          : {
              users: [
                {
                  id: sessionInfo.userId,
                  firstName: sessionInfo.userInfo.firstName,
                  lastName: sessionInfo.userInfo.lastName,
                  defaultTravelerId: travelerDefaultTravelerId,
                },
              ],
            },
        call(fetchUserPassengers, {}),
      ]);

      const hiddenTravelerIds =
        "corporateInfo" in sessionInfo
          ? (sessionInfo as CorpSessionInfo).corporateInfo.hiddenTravelerIds
          : [];

      const loggedInUserId = sessionInfo.userId;

      userPassengers = buildCorpTravelers(
        caponeUserPassengers,
        corpUsersList.users,
        hiddenTravelerIds,
        loggedInUserId
      );
    }

    yield put(
      setUserPassengers({
        userPassengerCallState: CallState.Success,
        userPassengers: userPassengers,
      })
    );
  } catch (e) {
    yield put(setUserPassengersCallStateFailed());
  }
}
